<script setup>
import {onMounted, ref, inject, watch} from "vue";
import needsService from "@/services/ecosystem/needs.service";
import {getLogo} from "@/helpers/logo";
import {useSingleRowItems} from "@/composables/useSingleRowItems";

const emit = defineEmits(["submitStartup"]);

const need = inject('need');
const updateStartups = inject('updateStartups');
const startups = ref([]);
const {rowRef} = useSingleRowItems();

onMounted(() => {
    getStartups();
});

watch(updateStartups, (value) => {
    if (value) {
        getStartups();
    }
});

async function getStartups() {
    const {data} = await needsService.getSuggestedStartups(need.value.id);
    startups.value = data;
}
</script>

<template>
    <div v-if="startups.length" class="dashboard-page__card need-admin__card--double">
        <div class="dashboard-page__card__inner">
            <h3 class="dashboard-page__title dashboard-page__title--ai">Suggested Startups</h3>

            <div class="dashboard-page__table dashboard-page__table-flexible">
                <table>
                    <tbody>
                    <tr v-for="startup in startups" :key="startup.id">
                        <td class="pl-0">
                            <div class="dashboard-page__table__title">
                                <div class="data-labels-set data-labels-set--lg">
                                    <span class="data-label">
                                        <img :src="getLogo(startup.logo)"/>
                                    </span>
                                </div>
                                <div>
                                    <h6 class="heading6"><a :href="`/startups/${startup.id}`" target="_blank">{{ startup.name }}</a></h6>
                                    <p>{{startup.score}}% match</p>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div
                                v-if="startup.categories.length"
                                class="status-plate-wrapper"
                                :ref="el => rowRef(el, startup.id)"
                            >
                                <span
                                    v-for="category in startup.categories"
                                    :key="category"
                                    data-row-item
                                    class="status-plate status-plate--unreviewed"
                                >
                                    {{ category }}
                                </span>
                            </div>
                        </td>
                        <td align="right" class="pr-0">
                            <button v-if="startup.submitted" disabled class="button button--lg button-secondary">
                                Startup Submitted
                            </button>

                            <button
                                v-else
                                class="button button--lg button-primary"
                                @click="emit('submitStartup', startup.id)"
                            >
                                Submit Startup
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
